import React from "react";
import Shape from "../../images/gq-shap.svg"
import Shape2 from "../../images/gq-shap-2.svg"


const GetquateSection = (props) => {
 
    return (
        <section className={`get-quate-section-s2 section-padding ${props.hclass}`}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-12">
                        <div className="content">
                            <div className="section-title">
                                <h2>Tecnologia <span>Smart</span> per una casa sempre fresca</h2>
                                <p>Kleeo utilizza un sistema di purificazione ionica a pressione negativa per catturare gli odori alla fonte, prima che possano diffondersi nell'ambiente.</p>
                            </div>
                            <div className="item-wrap">
                                <div className="year">
                                    <h3>65L</h3>
                                    <span>Volume Interno di Comfort</span>
                                </div>
                                <ul>
                                    <li><i className="ti-check"></i>Sensori a infrarossi e celle di carico ad alta precisione</li>
                                    <li><i className="ti-check"></i>Cassetto rifiuti sigillato da 9 litri (fino a 15gg di autonomia)</li>
                                    <li><i className="ti-check"></i>Integrazione totale con App Tuya per il monitoraggio salute</li>
                                </ul>
                            </div>
                            <ul className="buttom-item">
                                <li>
                                    <div className="text">
                                        <span>Monitoraggio Salute: traccia il peso del tuo gatto tramite l'App Tuya per prevenire anomalie.</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="text">
                                        <span>Manutenzione rapida: il tamburo è lavabile in pochi minuti.</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12"></div>
                </div>
            </div>
            <div className="shape">
                <img src={Shape} alt="" />
            </div>
            <div className="shape2">
                <img src={Shape2} alt="" />
            </div>
        </section>
    )
}
export default GetquateSection;